"use client";

import type { ReactNode } from "react";
import { useState } from "react";
import { useTranslations } from "next-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faMinus,
  faCircleInfo,
} from "@awesome.me/kit-c10ef98ed3/icons/classic/regular";

export interface InfoToastProps {
  title: string;
  content?: ReactNode;
  source?: ReactNode;
  onToggle?: () => void;
}

export default function InfoToast({
  title,
  content,
  source,
  onToggle,
}: InfoToastProps) {
  const t = useTranslations("questionnaire");
  const ta = useTranslations("aria");
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
    onToggle?.();
  };

  return (
    <div className="info-toast-container">
      <div className="info-toast">
        <div className="info-header">
          <FontAwesomeIcon
            icon={faCircleInfo}
            className="info-icon"
            aria-hidden
            focusable={false}
          />
          <span className="info-title">{title}</span>
        </div>
        <button
          className="toggle-button"
          onClick={handleToggle}
          aria-label={ta("toggle-information")}
          aria-expanded={isExpanded}
          type="button"
        >
          {isExpanded ? (
            <FontAwesomeIcon icon={faMinus} className="toggle-icon" />
          ) : (
            <FontAwesomeIcon icon={faPlus} className="toggle-icon" />
          )}
        </button>
      </div>
      {isExpanded && content && (
        <div className="expanded-content">
          <p className="content-text">{content}</p>
          {source && <p className="source-text">{source}</p>}
        </div>
      )}
    </div>
  );
}
